// @flow

export const contractDuration = [
  { value: 12, text: "12 Monate" },
  { value: 24, text: "24 Monate" },
];
